import {
  createTheme,
  responsiveFontSizes,
  adaptV4Theme,
} from '@mui/material/styles';
import { defaultStyles, overrides } from './defaults';

const theme = responsiveFontSizes(
  createTheme(adaptV4Theme({ ...defaultStyles, ...overrides })),
);

export default theme;
